var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotiService } from '@app/noti.service';
var ProfileComponent = /** @class */ (function () {
    function ProfileComponent(router, Route, fb, util, apiService, notiService) {
        this.router = router;
        this.Route = Route;
        this.fb = fb;
        this.util = util;
        this.apiService = apiService;
        this.notiService = notiService;
        this.isCompany = false;
        this.isForeign = false;
        this.submitted = false;
        this.isConsentAccept = false;
        this.isShownConsent = false;
        this.allowNews = false;
        this.lang = "th";
        this.form = this.fb.group({
            dpa_companyname: "",
            dpa_companytypeid: "",
            dpa_registrationid: "",
            dpa_authorizedperson: "",
            dpa_authorizedperson_idcard: "",
            dpa_authorizedperson_telephone: "",
            contactid: "",
            firstname: "",
            lastname: "",
            dpa_idcard: "",
            telephone1: "",
            emailaddress1: ['', this.emailValidator],
            birthdate: "",
            dpa_accountno: ['', Validators.required],
            dpa_contact_homeno: ['', Validators.required],
            dpa_contact_moo: "",
            dpa_contact_street: "",
            dpa_contact_subdistict: "",
            dpa_contact_distict: "",
            dpa_contact_province: "",
            dpa_contact_postcode: "",
            dpa_contact_country: "",
            dpa_contact_subdistictname: "",
            dpa_contact_distictname: "",
            dpa_contact_provincname: "",
            dpa_contact_postcodename: "",
            dpa_contact_countryname: "",
            dpa_allowemail: false,
            dpa_allowsms: false,
            dpa_portalflag: true,
            pid: ""
        });
    }
    ProfileComponent.prototype.ngOnDestroy = function () {
        if (this.notiSubscription) {
            this.notiSubscription.unsubscribe();
        }
    };
    ProfileComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            function matchCustom(params, data) {
                // If there are no search terms, return all of the data
                if ($.trim(params.term) === '') {
                    return data;
                }
                // Do not display the item if there is no 'text' property
                if (typeof data.text === 'undefined') {
                    return null;
                }
                if (params.term.length > 1) {
                    // `params.term` should be the term that is used for searching
                    // `data.text` is the text that is displayed for the data object
                    var cris = params.term.split(" ");
                    var found = true;
                    for (var i = 0; i < cris.length; i++) {
                        if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
                            found = false;
                            return null;
                        }
                    }
                    if (found) {
                        // You can return modified objects from here
                        // This includes matching the `children` how you want in nested data sets
                        return data;
                    }
                }
                // Return `null` if the term should not be displayed
                return null;
            }
            var thisTs, para, tmp, _a, thisTs_1, dataToken, Res, _b, firstname, lastname, name_1, i;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        thisTs = this;
                        this.Route.queryParams.subscribe(function (Params) {
                            _this.TokenID = Params["id"];
                        });
                        para = "dpaCode=PRIVACY_POLICY";
                        return [4 /*yield*/, this.apiService.get("crmservice", "getPolicy", para)];
                    case 1:
                        tmp = _c.sent();
                        if (!this.util.IsNullOrUndefined(tmp.policyDetail)) {
                            $("#proPolicy").html(tmp.policyDetail);
                        }
                        // boy add
                        this.util.ShowWaiting(true);
                        if (!(this.TokenID != null && this.TokenID != "" && this.TokenID != undefined)) return [3 /*break*/, 5];
                        _a = this;
                        return [4 /*yield*/, this.GetToken()];
                    case 2:
                        _a.TokenP = _c.sent();
                        if (!(this.TokenP.username == undefined)) return [3 /*break*/, 3];
                        this.util.ErrorDialog("Invalid token.");
                        $("#btnMainConfirm").off('click');
                        thisTs_1 = this;
                        $("#btnMainError").click(function () {
                            return __awaiter(this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    thisTs_1.router.navigate(["/mainmenu/index"]);
                                    return [2 /*return*/];
                                });
                            });
                        });
                        $("#btnSave").attr("disabled", "disabled");
                        return [3 /*break*/, 5];
                    case 3:
                        dataToken = {
                            contactid: this.TokenP.usernameidno,
                            emailaddress1: this.TokenP.username
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "updateContactEmail", dataToken)];
                    case 4:
                        Res = _c.sent();
                        this.util.SuccessDialog("ระบบทำการแก้ไขและบันทึกข้อมูลเรียบร้อยแล้ว");
                        $("#btnSuccessOK").click(function () {
                            return __awaiter(this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    thisTs.router.navigate(["/mainmenu/index"]);
                                    return [2 /*return*/];
                                });
                            });
                        });
                        _c.label = 5;
                    case 5:
                        this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (this.PortalUser == null || this.PortalUser.contactid == null || this.PortalUser.contactid == "") {
                            this.util.WarningDialog("กรุณาเข้าสู่ระบบ");
                            $("#btnWarningOK").off("click");
                            $("#btnWarningOK").click(function () {
                                thisTs.router.navigate(["/mainmenu/login"]);
                            });
                            return [2 /*return*/];
                        }
                        this.EmailBeforeChange = this.PortalUser.email;
                        this.util.ShowWaiting(true);
                        if (this.lang == "th") {
                            $(".select2-en").hide();
                            $(".select2-th").show();
                        }
                        else {
                            $(".select2-th").hide();
                            $(".select2-en").show();
                        }
                        this.notiSubscription = this.notiService.message.subscribe(function (_lang) {
                            _this.lang = _lang;
                            if (_this.lang == "th") {
                                $(".select2-en").hide();
                                $(".select2-th").show();
                            }
                            else {
                                $(".select2-th").hide();
                                $(".select2-en").show();
                            }
                            if (_this.contact != null) {
                                $(".select2").val(_this.contact.dpa_contact_subdistict + "|" + _this.contact.dpa_contact_distict + "|" + _this.contact.dpa_contact_province + "|" + _this.contact.dpa_contact_postcode + "|" + _this.contact.dpa_contact_country).trigger('change');
                            }
                            //this.bindAddress(this.lang)
                        });
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (this.cookieData == null) {
                            this.cookieData = {};
                        }
                        $('.select2th').select2({
                            matcher: matchCustom,
                            placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
                        });
                        $('.select2en').select2({
                            matcher: matchCustom,
                            placeholder: "Please select your address."
                        });
                        $(".select2").on("change", function (e) {
                            thisTs.addressChange(e.target.value);
                        });
                        return [4 /*yield*/, this.initdropdown()];
                    case 6:
                        _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.getContact()];
                    case 7:
                        _b.contact = _c.sent();
                        if (this.cookieData != null) {
                            this.contact.pid = this.cookieData.pid;
                        }
                        this.mapDataToForm(this.contact);
                        $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change');
                        this.allowNews = this.contact.dpa_allowemail || this.contact.dpa_allowsms;
                        if (this.contact != null && this.contact.birthdate != null && this.contact.birthdate.trim().length != 0) {
                            $("#dob").datepicker("setDate", new Date(this.contact.birthdate));
                        }
                        if (this.contact.dpa_companytypeid != null && this.contact.dpa_companytypeid.trim().length > 0) {
                            this.isCompany = true;
                            firstname = "";
                            lastname = "";
                            try {
                                name_1 = this.contact.dpa_authorizedperson.split(" ");
                                if (name_1.length > 0) {
                                    if (name_1.length == 1) {
                                        firstname = name_1[0];
                                    }
                                    else if (name_1.length == 2) {
                                        firstname = name_1[0];
                                        lastname = name_1[1];
                                    }
                                    else {
                                        for (i = 0; i < name_1.length - 1; i++) {
                                            firstname += " " + name_1[i];
                                        }
                                        firstname = firstname.trim();
                                        lastname = name_1[name_1.length - 1];
                                    }
                                }
                            }
                            catch (e) {
                                console.log(e);
                            }
                            this.form.controls["firstname"].setValue(firstname);
                            this.form.controls["lastname"].setValue(lastname);
                        }
                        else {
                            this.isForeign = this.contact != null && this.contact.dpa_passport != null && this.contact.dpa_passport.trim() != '';
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProfileComponent.prototype.GetToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.get("crmservice", "getToken", "token_id=" + this.TokenID)];
                    case 1:
                        Res = _a.sent();
                        if (Res != null) {
                            return [2 /*return*/, Res];
                        }
                        return [2 /*return*/, Res];
                }
            });
        });
    };
    ProfileComponent.prototype.initdropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.apiService.getMasterAddress()];
                    case 1:
                        _a.combinedAddressList = _b.sent();
                        this.setAddressEn();
                        if (this.contact != null) {
                            $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProfileComponent.prototype.setAddressEn = function () {
        if (this.combinedAddressList != null && this.combinedAddressList.length > 0) {
            this.combinedAddressListEn = this.combinedAddressList.slice().sort(function (a, b) {
                if (a.text_eng < b.text_eng) {
                    return -1;
                }
                if (a.text_eng > b.text_eng) {
                    return 1;
                }
                return 0;
            });
        }
    };
    Object.defineProperty(ProfileComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    ProfileComponent.prototype.addressChange = function (value) {
        var selected = this.combinedAddressList.filter(function (a) { return a.id == value; });
        if (selected != null && selected.length > 0) {
            var values = selected[0].id.split("|");
            var texts = void 0;
            if (this.lang == "th") {
                texts = selected[0].text.split(" | ");
            }
            else {
                texts = selected[0].text_eng.split(" | ");
            }
            this.formControl["dpa_contact_subdistict"].setValue(values[0]);
            this.formControl["dpa_contact_distict"].setValue(values[1]);
            this.formControl["dpa_contact_province"].setValue(values[2]);
            this.formControl["dpa_contact_postcode"].setValue(values[3]);
            this.formControl["dpa_contact_country"].setValue(values[4]);
            this.formControl["dpa_contact_subdistictname"].setValue(texts[0]);
            this.formControl["dpa_contact_distictname"].setValue(texts[1]);
            this.formControl["dpa_contact_provincname"].setValue(texts[2]);
            this.formControl["dpa_contact_postcodename"].setValue(texts[3]);
            this.formControl["dpa_contact_countryname"].setValue(texts[4]);
        }
        else {
            this.formControl["dpa_contact_subdistict"].setValue("");
            this.formControl["dpa_contact_distict"].setValue("");
            this.formControl["dpa_contact_province"].setValue("");
            this.formControl["dpa_contact_postcode"].setValue("");
            this.formControl["dpa_contact_country"].setValue("");
            this.formControl["dpa_contact_subdistictname"].setValue("");
            this.formControl["dpa_contact_distictname"].setValue("");
            this.formControl["dpa_contact_provincname"].setValue("");
            this.formControl["dpa_contact_postcodename"].setValue("");
            this.formControl["dpa_contact_countryname"].setValue("");
        }
    };
    ProfileComponent.prototype.emailValidator = function (control) {
        if (control.value) {
            var matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
            return matches ? null : { 'invalidEmail': true };
        }
        else {
            return null;
        }
    };
    ProfileComponent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var dob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!(this.form.valid && this.isValidForm())) return [3 /*break*/, 2];
                        this.util.ShowWaiting(true);
                        dob = $('#dob').val();
                        if (dob == null || dob.trim().length == 0) {
                            this.formControl["birthdate"].setValue("");
                        }
                        else {
                            //this.formControl["birthdate"].setValue($('#dob').data('datepicker').date.toISOString())
                            this.formControl["birthdate"].setValue($("#dob").datepicker({ dateFormat: "dd/MM/yyyy" }).val());
                        }
                        if (this.isCompany) {
                            this.form.controls["dpa_authorizedperson"].setValue(this.form.get("firstname").value + " " + this.form.get("lastname").value);
                            //this.form.controls["dpa_authorizedperson_idcard"].setValue(this.form.get("dpa_idcard").value);
                            //this.form.controls["dpa_authorizedperson_telephone"].setValue(this.form.get("telephone1").value);
                            this.form.controls["firstname"].setValue("");
                            this.form.controls["lastname"].setValue("");
                            this.form.controls["dpa_idcard"].setValue("");
                        }
                        this.form.controls["dpa_allowemail"].setValue(true);
                        this.form.controls["dpa_allowsms"].setValue(true);
                        this.EmailAfterChange = this.form.get("emailaddress1").value;
                        this.form.controls["emailaddress1"].setValue(this.EmailBeforeChange);
                        return [4 /*yield*/, this.apiService.postCustomApi("User", "UpdatePortalProfile", this.form.value).then(function (res) {
                                if (_this.util.isSuccessResponse(res) && res == _this.form.controls["contactid"].value) {
                                    _this.registerDROS();
                                    var thisTs_2 = _this;
                                    var txtSuccess = "ระบบทำการแก้ไขและบันทึกข้อมูลเรียบร้อยแล้ว ";
                                    if (_this.EmailAfterChange != _this.EmailBeforeChange) {
                                        txtSuccess += "<br> กรุณายืนยันการเปลี่ยน Email จาก link ที่ส่งไปที่เมล์ล่าสุดที่ทำการแก้ไข";
                                    }
                                    _this.util.SuccessDialog(txtSuccess);
                                    $("#btnSuccessOK").click(function () {
                                        return __awaiter(this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                thisTs_2.router.navigate(["/mainmenu/index"]);
                                                return [2 /*return*/];
                                            });
                                        });
                                    });
                                }
                                else {
                                    _this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ");
                                }
                                _this.util.ShowWaiting(false);
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ProfileComponent.prototype.SendEmail = function (TokenID) {
        return __awaiter(this, void 0, void 0, function () {
            var MailObj, url, MailContent, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        MailObj = {
                            contactid: this.PortalUser.contactid,
                            dpa_name: this.PortalUser.firstname + " " + this.PortalUser.lastname
                        };
                        url = this.util.baseUrl() + "/mainmenu/profile?id=" + TokenID;
                        MailContent = "เรียน คุณ" + this.PortalUser.firstname + " " + this.PortalUser.lastname + "<br /><br />" +
                            "   คุณได้ทำการเปลี่ยน Email ในระบบ Customer Web Portal ของสถาบันคุ้มครองเงินฝาก <br />" +
                            "โปรดคลิกลิงค์ด้านล่างเพื่อทำการยืนยันว่า Email ที่เปลี่ยนนี้ถูกต้อง และทำการบันทึกข้อมูล <br /><br />" +
                            '<a target="_blank" href="' + url + '">Confirm Email</a><br /><br />' +
                            "ขอแสดงความนับถือ <br />" +
                            "สถาบันคุ้มครองเงินฝาก <br />" +
                            "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
                            "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
                            "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
                            "โทร : 02-272-0300";
                        MailObj.dpa_description = MailContent;
                        MailObj.dpa_emailaddress = this.EmailAfterChange;
                        return [4 /*yield*/, this.apiService.post("crmservice", "sendEmailUpdate", MailObj)];
                    case 1:
                        Res = _a.sent();
                        return [2 /*return*/, Res];
                }
            });
        });
    };
    ProfileComponent.prototype.close = function () {
        window.close();
    };
    ProfileComponent.prototype.telephoneOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            if (charCode == 35 || charCode == 44) {
                return true;
            }
            return false;
        }
        return true;
    };
    ProfileComponent.prototype.numberOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    };
    ProfileComponent.prototype.getContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "contactid=" + this.cookieData.contactid;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp[0]];
                }
            });
        });
    };
    ProfileComponent.prototype.consentAcceptChange = function (target) {
        this.isConsentAccept = target.checked;
        if (!this.isShownConsent) {
            this.showConsent();
            this.isShownConsent = true;
        }
    };
    ProfileComponent.prototype.newsAllowChange = function (target) {
        this.form.controls["dpa_allowemail"].setValue(target.checked);
        this.form.controls["dpa_allowsms"].setValue(target.checked);
    };
    ProfileComponent.prototype.showConsent = function () {
        this.isShownConsent = true;
        $("#consentModal").modal('show');
    };
    ProfileComponent.prototype.mapDataToForm = function (data) {
        var _this = this;
        Object.keys(data).forEach(function (key) {
            if (_this.form.controls[key]) {
                _this.form.controls[key].setValue(data[key]);
            }
            else {
                _this.form.addControl(key, new FormControl(data[key]));
            }
        });
        setTimeout(function () {
            _this.util.ShowWaiting(false);
        }, 600);
    };
    ProfileComponent.prototype.registerDROS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var idcard, para, tmp, UID, SubdistictCode, PostalName, SubdistictObj, PostalObj, arrAddr, rowAddr, birthdateYYYYMMDD, rowSave, Res, Token, Res2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idcard = this.form.get("dpa_idcard").value;
                        if (this.isCompany) {
                            idcard = this.form.get("dpa_registrationid").value;
                        }
                        para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false&CRM06=true";
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)];
                    case 1:
                        tmp = _a.sent();
                        if (!!this.util.IsNullOrUndefined(tmp.CRM06)) return [3 /*break*/, 8];
                        UID = tmp.CRM06.UID;
                        SubdistictCode = "";
                        PostalName = "";
                        return [4 /*yield*/, this.apiService.postCustomApi("master", "Subdistrict", { id: this.form.get("dpa_contact_subdistict").value })];
                    case 2:
                        SubdistictObj = _a.sent();
                        return [4 /*yield*/, this.apiService.postCustomApi("master", "Postalcode", { id: this.form.get("dpa_contact_postcode").value })];
                    case 3:
                        PostalObj = _a.sent();
                        if (!this.util.IsNullOrUndefined(SubdistictObj)) {
                            SubdistictCode = SubdistictObj[0].dpa_code;
                        }
                        if (!this.util.IsNullOrUndefined(PostalObj)) {
                            PostalName = PostalObj[0].dpa_name;
                        }
                        arrAddr = [];
                        rowAddr = {
                            addressType: "2",
                            addressNo: this.form.get("dpa_contact_homeno").value,
                            villageName: null,
                            floor: null,
                            mooNo: this.form.get("dpa_contact_moo").value,
                            soiName: null,
                            streetName: this.form.get("dpa_contact_street").value,
                            locationCode: SubdistictCode,
                            zipcode: PostalName
                        };
                        birthdateYYYYMMDD = "";
                        if (this.form.get("birthdate").value != "") {
                            birthdateYYYYMMDD = moment(this.form.get("birthdate").value).format("YYYY/MM/DD");
                        }
                        arrAddr.push(rowAddr);
                        rowSave = {
                            uid: UID,
                            idNo: idcard,
                            title: null,
                            firstName: !this.isCompany ? this.form.get("firstname").value : this.form.controls["dpa_companyname"].value,
                            lastName: !this.isCompany ? this.form.get("lastname").value : "",
                            birthdate: birthdateYYYYMMDD,
                            mobileNo: !this.isCompany ? this.form.get("telephone1").value : this.form.get("dpa_authorizedperson_telephone").value,
                            email: this.EmailBeforeChange,
                            address: arrAddr
                        };
                        console.log(rowSave);
                        return [4 /*yield*/, this.apiService.post("DROS", "register", rowSave)];
                    case 4:
                        Res = _a.sent();
                        console.log(Res);
                        Token = {
                            contactid: idcard,
                            emailaddress1: this.EmailAfterChange
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "createToken", Token)];
                    case 5:
                        Res2 = _a.sent();
                        if (!(Res2 != null)) return [3 /*break*/, 7];
                        if (!(this.EmailAfterChange != this.EmailBeforeChange)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.SendEmail(Res2["ticketnumber"])];
                    case 6:
                        Res2 = _a.sent();
                        _a.label = 7;
                    case 7:
                        console.log(Res2);
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ProfileComponent.prototype.isValidForm = function () {
        return true;
    };
    return ProfileComponent;
}());
export { ProfileComponent };



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts.pre-build-optimizer.js